import { Box, Typography, useTheme } from '@mui/material';
import { Button, Modal, ModalProps, TextInput } from 'components/ui';
import React, { ReactElement, useState } from 'react';


export interface AddGroupModalProps
  extends Pick<ModalProps, 'open' | 'onClose'> {
  onSuccess?: (title: string) => void;
}

export const AddGroupModal = ({
  open,
  onClose,
  onSuccess,
}: AddGroupModalProps): ReactElement => {
  const theme = useTheme();

  const [title, setTitle] = useState('');
  const [error, setError] = useState('');

  const handleSave = () => {
    if (!title) {
      setError('Title is required');
      return;
    }
    onSuccess?.(title);
  };

  return (
    <Modal title="Add approval group" open={open} onClose={onClose}>
      <Box sx={{ width: 500, maxWidth: '80vw' }}>
        <Box width="100%" maxWidth={450}>
          <Box
            display="flex"
            alignItems="center"
            gap={{ xs: 1, md: 0 }}
            flexDirection={{ xs: 'column', sm: 'row' }}
            width="100%"
          >
            <Box flex={1} width={300}>
              <TextInput
                label="Title"
                width="100%"
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
            </Box>
          </Box>
          {error && (
            <Typography
              style={{
                color: theme.palette.error.main,
                fontWeight: 400,
                fontSize: 14,
              }}
            >
              {error}
            </Typography>
          )}
        </Box>
      </Box>

      <Box mt={30} display="flex">
        <Box mr={30}>
          <Button minWidth={100} inverted onClick={onClose}>
            Cancel
          </Button>
        </Box>
        <Button
          minWidth={100}
          variant="vibrant"
          disabled={!title}
          onClick={handleSave}
        >
          Save
        </Button>
      </Box>
    </Modal>
  );
};
